import React from "react";
import About from "./about";
import FormDesktop from "./formDesktop";
import FormDeskLa from "./formDeskLa";
import Thanks from "./thanks";

const Index = ({ siteName }) => {
  const [showForm, setShowForm] = React.useState("about");

  return (
    <>
      {showForm === "about" ? (
        <>
          <About setShowForm={setShowForm} />
        </>
      ) : showForm === "form" && siteName === "welcome" ? (
        <>
          <FormDesktop setShowForm={setShowForm} siteName={siteName}/>
        </>
      ) : showForm === "form" && siteName === "lacanada" ? (
        <>
          <FormDeskLa setShowForm={setShowForm} siteName={siteName}/>
        </>
      ) : showForm === "thanks" ? (
        <>
          <Thanks />
        </>
      ) : null}
    </>
  );
};

export default Index;
